import CreateAccountButton from "@components/CreateAccountButton/CreateAccountButton";
import { Stack, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { StackStyled } from "./FacturationHome.style";

const FacturationHome = ({ user }) => {
  const { t } = useTranslation();
  return (
    <StackStyled>
      <Typography variant="h2" textAlign={"center"}>
        {t("home.facturation_title")}
      </Typography>
      <Typography className="facturation_desc">
        {t("home.facturation_desc")}
      </Typography>
      {!user && <CreateAccountButton />}
      <Typography className="sub-title">
        {t("home.facturation_sub_title")}
      </Typography>
    </StackStyled>
  );
};

export default FacturationHome;
